var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNonVerified(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.52128 1.85106C7.54611 1.85106 9.18798 3.49076 9.19148 5.51478C9.49145 5.5942 9.77302 5.71884 10.0285 5.88096C10.0378 5.76229 10.0426 5.64234 10.0426 5.52128C10.0426 3.02424 8.01831 1 5.52128 1C3.02424 1 1 3.02424 1 5.52128C1 8.01831 3.02424 10.0426 5.52128 10.0426C5.64234 10.0426 5.76229 10.0378 5.88096 10.0285C5.71884 9.77302 5.5942 9.49145 5.51478 9.19148C3.49076 9.18798 1.85106 7.54611 1.85106 5.52128C1.85106 3.49427 3.49427 1.85106 5.52128 1.85106Z",
    fill: "#FDAA09"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.11765 8.70228V7.11765H8.76471V8.70228H8.11765Z",
    fill: "#FDAA09"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.11765 9.01921H8.76471V9.70588H8.11765V9.01921Z",
    fill: "#FDAA09"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 8.42021C11 9.84499 9.84499 11 8.42021 11C6.99544 11 5.84043 9.84499 5.84043 8.42021C5.84043 6.99544 6.99544 5.84043 8.42021 5.84043C9.84499 5.84043 11 6.99544 11 8.42021ZM10.1489 8.42021C10.1489 9.37496 9.37496 10.1489 8.42021 10.1489C7.46547 10.1489 6.69149 9.37496 6.69149 8.42021C6.69149 7.46547 7.46547 6.69149 8.42021 6.69149C9.37496 6.69149 10.1489 7.46547 10.1489 8.42021Z",
    fill: "#FDAA09"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6 2.64706H5.11765V5.11765H3.52941V6H6V2.64706Z",
    fill: "#FDAA09"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNonVerified);
export default __webpack_public_path__ + "static/media/NonVerified.518141d01fc31a304cafc7769945239e.svg";
export { ForwardRef as ReactComponent };